<template>
    <div id="document">
        <Navi currentPage="5" style="position:fixed"></Navi>
        <div style="height:60px"></div>
        <div class="body_container main_context">
            <div style="height:10px;width:100%;background-color: #FFFFFF;position:fixed"></div>
            <div style="height:10px;width:100%;background-color: #FFFFFF;"></div>
            <div class="breadcrumb_con" style="position:fixed;width:1180px;margin-top:0px">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Document</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div style="height:50px"></div>
                <div style="position:fixed;">
                    <el-button
                        :icon="fold_icon"
                        style="background-color: #F7F7F7;border-radius: 0px;border:0px"
                        @click="setManu"
                        size="small"
                    ></el-button>
                </div>
                <div><el-button size="small" :icon="fold_icon" style="background-color: #F7F7F7;border-radius: 0px;border:0px;visibility: hidden"></el-button></div>
            <el-container>
                <el-aside :width="manu_width" class="mamu_div" v-if="!isCollapse" style="position:fixed;z-index:10">
                    <el-menu
                        class="manu"
                        @open="handleOpen"
                        @close="handleClose"
                        :default-openeds="open_titles"
                        :default-active="active_ach_id"
                        @select="handleSelect"
                    >
                        <el-submenu v-for="x of titles" :key="x.label" :index="x.ach_id">
                            <span slot="title" class="el-h1-title">{{ x.label }}</span>
                            <!-- <template slot="title">
                                <i class="el-icon-location"></i>
                                <span slot="title">{{x.label}}</span>
                            </template>-->
                            <el-menu-item v-for="s of x.children" :key="s.label" :index="s.ach_id">
                                <span slot="title" class="el-h2-title">{{ s.label }}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-aside :width="manu_width"></el-aside>
                <el-main class="main_con">
                    <div class="main_con_div">
                        <div class="para" v-for="ps of show_con" :key="ps.title">
                            <div class="pcga-doc-h">{{ ps.title }}</div>
                            <div class="pcga-doc-p" v-for="(p,i) of ps.paras" :key="i" v-html="p"></div>
                        </div>
                        <div class="footer-nav">
                            <el-link
                                :underline="false"
                                @click="formerPart"
                                v-if="all_titles.indexOf(active_ach_id) != 0"
                                style="float:left"
                            >
                                <i class="el-icon-arrow-left"></i>
                                {{ form_item }}
                            </el-link>
                            <el-link
                                style="float:right"
                                :underline="false"
                                @click="nextPart"
                                v-if="all_titles.indexOf(active_ach_id) != all_titles.length - 1"
                            >
                                {{ next_item }}
                                <i class="el-icon-arrow-right"></i>
                            </el-link>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import intro_img from '@/assets/img/intro_pcga.png'
import ga_img from '@/assets/img/GA.png'
import imp_img from '@/assets/img/pcga_imp.png'
import cell_img from '@/assets/img/cell_doc.png'
import phenotype_img from '@/assets/img/gwas_doc.png'
import analyze_1 from '@/assets/img/analyze_1.png'
import analyze_2 from '@/assets/img/analyze_2.png'
import analyze_3 from '@/assets/img/analyze_3.png'
import analyze_4 from '@/assets/img/analyze_4.png'
import analyze_4_1 from '@/assets/img/analyze_4-1.png'
import analyze_4_2 from '@/assets/img/analyze_4-2.png'
import analyze_4_3 from '@/assets/img/analyze_4-3.png'
import search_1 from '@/assets/img/search_1.png'

import browse_1 from '@/assets/img/browse_1.png'
import browse_2 from '@/assets/img/browse_2.png'

import {backTop,pcga_options_tips} from '@/bus.js'

export default {
    name: 'documents',
    components: { Navi, Footer },
    data: function () {
        var label_tips=pcga_options_tips;
        var tips_explanation_table='<tr><th>Option label</th><th>Explanation</th></tr>';
        for(var k in label_tips){
            var v=label_tips[k]
            tips_explanation_table+='<tr><td>'+v['label']+'</td><td>'+v['tip']+'</td></tr>'
        }
        return {
            fold_icon:"el-icon-s-fold",
            all_titles: ['1-1', '1-2', '1-3', '1-5', '1-6','1-7', '1-8','1-9','2-1', '2-2', '2-3'],
            titles: [{
                'label': 'About PCGA', 'ach_id': '1', 'children': [
                    { 'label': 'Introduction', 'ach_id': '1-1' },
                    { 'label': 'Framework', 'ach_id': '1-2' },
                    { 'label': 'Dataset', 'ach_id': '1-3' },
                    // { 'label': 'Performance', 'ach_id': '1-4' },
                    { 'label': 'Implementation', 'ach_id': '1-5' },
                    { 'label': 'Browser Compatibility', 'ach_id': '1-6' },
                    { 'label': 'Citations', 'ach_id': '1-7' },
                    { 'label': 'Data Privacy', 'ach_id': '1-8' },
                    { 'label': 'Updates', 'ach_id': '1-9' },
                ]
            },
            {
                'label': 'Tutorial', 'ach_id': '2', 'children': [
                    { 'label': 'Analyze', 'ach_id': '2-1' },
                    { 'label': 'Search', 'ach_id': '2-2' },
                    { 'label': 'Browse', 'ach_id': '2-3' },
                    // { 'label': 'API service', 'ach_id': '2-4' },
                ]
            }],
            open_titles: ['1', '2'],
            active_ach_id: '1-1',
            isCollapse: false,
            manu_width: '240px',
            con_text: {
                '1-1': [
                    {
                        title: 'Introduction', paras:
                            ['Most complex disease-associated loci mapped by genome-wide association studies (GWAS) are located in non-coding regions. \
                            It remains elusive which genes the associated loci regulate and in which tissues/cell types the regulation occurs. Here, \
                            we present PCGA (<a href="https://pmglab.top/pcga">https://pmglab.top/pcga</a>), a comprehensive web server for jointly estimating both associated tissues/cell \
                            types and susceptibility genes for complex phenotypes by GWAS summary statistics. The web server is built on our published \
                            method, DESE, which represents an effective method to mutually estimate driver tissues and genes by integrating GWAS summary \
                            statistics and transcriptome data. By collecting and processing extensive bulk and single-cell RNA sequencing datasets, PCGA \
                            has included expression profiles of 54 human tissues, 2,214 human cell types and 4,384 mouse cell types, which provide the basis \
                            for estimating associated tissues/cell types and genes for complex phenotypes. We develop a framework to sequentially estimate \
                            associated tissues and cell types of a complex phenotype according to their hierarchical relationships we curated. Meanwhile, \
                            we construct a phenotype-cell-gene association landscape by estimating the associated tissues/cell types and genes of 1,871 \
                            public GWASs. The association landscape is generally consistent with biological knowledge and can be searched and browsed \
                            at the PCGA website. ',
                             '<img src="'+ga_img+'" width="70%"></img><br><span style="font-weight:bold">Figure 1. Graphical Abstract</span> (<a href="https://doi.org/10.1093/nar/gkac425">NAR (2022), gkac425</a>)',
                            ]
                    },
                ],
                '1-2': [
                    {
                        title: 'Framework', paras:
                            ['<span style="font-weight:bold">DESE workflow: </span> \
                            DESE (driver-tissue estimation by selective expression) consists of main three components, \
                            (1) conditional gene-based association analysis by an effective chi-square test, (2) estimating driver tissues according \
                            to selective expression of the conditionally associated genes, and (3) ranking genes according to their selective \
                            expression in the estimated driver tissues. Based on the inputs of GWAS summary statistics and gene expression \
                            of multiple tissues, they run iteratively to output a converged list of driver tissues and susceptibility genes \
                            (as byproduct) with statistical p values (Figure 1A). The details could be found in\
                             <a href="https://genomebiology.biomedcentral.com/articles/10.1186/s13059-019-1801-5#Sec38" target="_blank">here</a>.',
                            '<span style="font-weight:bold">PCGA workflow: </span> \
                            PCGA (phenotype-cell-gene association analysis platform) firstly estimates driver tissues with bulk-cell transcriptome dataset by DESE. \
                            Then PCGA estimates driver cell types with single-cell transcriptome dataset belonging to driver tissues by DESE again (Figure 1B).',
                            '<span style="font-weight:bold">PCGA landscape: </span> \
                            We estimated associated tissues, cell types and genes of 1,871 public GWASs by the above workflow to construct a phenotype-cell-gene \
                            association landscape. The association landscape can be searched and visualized in the PCGA web server (Figure 1C).',                     
                                '<img src="'+intro_img+'" width="100%"></img><br><span style="font-weight:bold">Figure 2. Workflow of DESE and PCGA</span> (<a href="https://doi.org/10.1093/nar/gkac425">NAR (2022), gkac425</a>)',
                            ]
                    },
                ],
                '1-3': [
                    {
                        title: 'Dataset', paras:
                            ['<span style="font-weight:bold">Transcriptome datasets: </span>\
                            PCGA included bulk-cell expression profiles and single-cell expression profiles. The bulk-cell expression profiles were curated from GTEx v8, which containing thousands of samples \
                            across 54 human tissues (organs). We normalized expression values by <a href="https://genomebiology.biomedcentral.com/articles/10.1186/gb-2010-11-3-r25">TMM</a> \
                            (trimmed mean of M values) and CPM (count per million) across all samples, which were used for estimating driver tissues in DESE. The single-cell expression \
                            profiles included human and mouse datasets. The human single-cell transcriptome were from PanglaoDB, Human Cell Landscape and Allen Brain Atlas. We calculated single-cell type based \
                            expression profiles by averaging top 10% single cell UMI counts. The mouse single cell expression profiles were curated from PanlaoDB. We mapped the mouse gene to their homologous \
                            human genes.',
                             '<img src="'+cell_img+'" width="100%"></img><br><span style="font-weight:bold">Figure 3. Count of tissues/single cell types in PCGA</span>',
                            '<span style="font-weight:bold">GWAS datasets: </span>\
                            We curated 1,871 GWAS summary statistics (sample size > 10,000) with full alleles records from Gene Atlas, GWAS Atlas and Neale Lab UKBB v3 according to the curation rules of CAUSALdb, \
                            which integrated large numbers of publicly available GWAS summary statistics. That is, only GWAS datasets that simultaneously appear in the three databases and CAUSALdb \
                            were curated. Therefore, all the 1,871 GWASs could be mapped to CAUSALdb. The population information, sample size, and mapped MeSH terms were exacted from CAUSALdb. \
                             It should be noted that GWAS Atlas collected the information of GWAS summary statistics from non-UKBB cohort while these datasets actually were provided by other \
                             websites, such as GRASP and PGC19. Here these datasets were regarded as the GWAS datasets from GWAS Atlas. We exacted the P-values and chromosome coordinates of all available variants. Non-GRCh37 coordinates were converted to GRCh37 coordinates, and \
                             the variants that couldn’t be converted were removed.',
                              '<img src="'+phenotype_img+'" width="100%"></img><br><span style="font-weight:bold">Figure 4. GWAS datasets</span>',
                            ]
                    },
                ],
                '1-4': [
                    {
                        title: 'Introduction', paras:
                            [' After centuries of genetic studies, one of the most fundamental questions, i.e., in what cell types do DNA mutations regulate a phenotype,\
                        remains unanswered for most complex phenotypes. The current availability of hundreds of genome-wide association studies (GWASs)\
                        and single-cell RNA sequencing (scRNA-seq) of millions of cells provides a unique opportunity to address the question.',
                                'Then, ...',
                            ]
                    },
                ],
                '1-5': [
                    {
                        title: 'Implementation', paras:
                            ['PCGA is built with PHP and deployed on the Nginx server in the laboratory. The backend database of PCGA uses MongoDB. The PCGA front end \
                            is developed based on VUE2 and uses Element-UI components. In the front-end visualization, PCGA uses Echarts graphics plug-in and vxe-table \
                            table plug-in. After a PCGA jobs is submitted, a unique task link will be provided to the user. The link allows user to monitor the status of \
                            their current jobs and access their results. Jobs submitted by users will be automatically submitted to our high-performance computing cluster. \
                            PCGA\'s core computing framework, DESE, is a Java-based program.',
                            // '<img src="'+implement_img+'" width="100%"></img><br><span style="font-weight:bold">Figure 2. Implementation environment</span>'
                            '<table class="qgg-table"><tbody>\
                            <tr><th>Software/Library</th><th>Version</th></tr>\
                            <tr><td>Nginx</td><td>1.18.0</td></tr>\
                            <tr><td>MongoDB</td><td>4.4.10</td></tr>\
                            <tr><td>PHP</td><td>7.3.23</td></tr>\
                            <tr><td>VUE</td><td>2.5.2</td></tr>\
                            <tr><td>Element-UI</td><td>2.15.7</td></tr>\
                            <tr><td>Echarts</td><td>4.8.0</td></tr>\
                            <tr><td>vxe-table</td><td>3.4.10</td></tr>\
                            </tbody></table>',
                            '<img src="'+imp_img+'" width="60%"></img><br><span style="font-weight:bold">Figure 5. PCGA Implementation</span> (<a href="https://doi.org/10.1093/nar/gkac425">NAR (2022), gkac425</a>)',
                            ]
                    },
                ], '1-6': [
                    {
                        title: 'Browser Compatibility', paras:
                            ['<table class="qgg-table"><tbody>\
                            <tr><th>OS</th><th>Version</th><th>Chrome</th><th>Firefox</th><th>Microsoft Edge</th><th>Safari</th></tr>\
                            <tr><td>Linux</td><td>CentOS 7</td><td>93.0.4577.82</td><td>94.0.2</td><td>n/a</td><td>n/a</td></tr>\
                            <tr><td>MacOS</td><td>HighSierra</td><td>93.0.4577.82</td><td>94.0.2</td><td>n/a</td><td>13.1.2</td></tr>\
                            <tr><td>Windows</td><td>10</td><td>93.0.4577.82</td><td>94.0.2</td><td>96.0.1054.53</td><td>n/a</td></tr>\
                            </tbody></table>',
                            ]
                    },
                    
                ],'1-7': [
                    {
                        title: 'Citations', paras:
                            ['Please CITE if you are using this web server: ',
                            '1. Xue C., Jiang L., Zhou M., Long Q., Chen Y., Li X., Peng W., Yang Q., Li M. (2022). \
                            PCGA: a comprehensive web server for phenotype-cell-gene association analysis. Nucleic Acids Research, gkac425. <a href="https://doi.org/10.1093/nar/gkac425">DOI</a> <a href="https://pubmed.ncbi.nlm.nih.gov/35639771/">PubMed</a>',
                            '2. Jiang L., Xue C., Dai S., Chen S., Chen P., Sham P. C., ... & Li M. (2019). DESE: estimating \
                             driver tissues by selective expression of genes associated with complex diseases or traits. Genome biology, 20(1), 1-19.  <a href="https://pubmed.ncbi.nlm.nih.gov/31694669/">PubMed</a>',
                            '3. Li M., Jiang L., Mak T. S. H., Kwan J. S. H., Xue C., Chen P., ... & Sham P. C. (2019). A powerful conditional gene-based \
                            association approach implicated functionally important genes for schizophrenia. Bioinformatics, 35(4), 628-635. <a href="https://pubmed.ncbi.nlm.nih.gov/30101339/">PubMed</a>',
                            'If you use the EMIC function, please also CITE the paper: ',
                            '4. Jiang L., Miao L., Yi G., Li X., Xue C., Li MJ, Huang H, Li M (2022). \
                            Powerful and robust inference of complex phenotypes\' causal genes with dependent expression quantitative loci by a median-based Mendelian randomization. Am J Hum Genet, 109(5):838-856. \
                            <a href="https://pubmed.ncbi.nlm.nih.gov/35460606/">PubMed</a>',
                            ]
                    },
                    
                ],'1-8': [
                    {
                        title: 'Data Privacy', paras:
                            ['<p> We promise to keep every user\'s submitted data private.</p> \
                            <span class="doc-sub-h1">Uploaded GWAS summary statistic file</span>\
                            <p>User-uploaded GWAS summary statistic file is temporarily stored on our server and cannot be accessed by anyone. After the job is completed, \
                             the GWAS summary file will be deleted immediately from our server. </p>\
                             ',
                             '<span class="doc-sub-h1">PCGA results</span>\
                            <p>After submitting a job, the user will be assigned a unique link to check the results, please save the link and do not leak it. \
                            Thirty days after the job is completed, the job link will expire and the resulting data will be deleted from the server. \
                            So please check and download the results in time. </p>\
                             '
                            ]
                    },
                    
                ],'1-9': [
                    {
                        title: 'Updates', paras:
                            ['<span class="doc-sub-h1">2023.03.10</span>\
                            <p>Add a permutation function to correct the multiple testing for associated tissues and cell types.</p>\
                             ',
                             '<span class="doc-sub-h1">2022.06.05</span>\
                            <p>The <a href="https://pubmed.ncbi.nlm.nih.gov/35460606" target="_blank">EMIC</a> method for causal gene inference is implemented in PCGA. EMIC infers gene expressions’ causal effect on a complex phenotype with dependent \
                            expression quantitative loci by a robust median-based Mendelian randomization. </p>\
                             ',
                            '<span class="doc-sub-h1">2021.12.10</span>\
                            <p>First release of <a href="https://pubmed.ncbi.nlm.nih.gov/35639771" target="_blank">PCGA</a>. The PCGA web server includes reference gene expression profiles of 54 tissues and 6,598 single cell types. The PCGA also includes phenotype-cell-gene association \
                            landscape by analyzing 1,871 public GWASs.</p>\
                             ',
                            ]
                    },
                    
                ],
                 '2-1': [
                    {
                        title: 'Analyze', paras:
                            ['<span class="doc-sub-h1">Step 1. Upload your GWAS P-values file </span>\
                            <img src="'+analyze_1+'" width="100%" class="shot_pic"></img><br>\
                             <p>The GWAS summary file must be a tab or comma delimited text file containing three columns with header, i.e., \
                             chromosome number, base pair postion (based on hg19/38) and p value. </p>\
                             <p><span style="font-style:italic; font-weight:550;font-size:14px">Example GWAS summary file format:</span></p>\
                                <p>Comma delimited text file: </p>\
                                <div class="code">\
                                    CHR,BP,P<br>\
                                    1,10000,1e-5<br>\
                                    1,102000,0.09<br>\
                                    2,102000,0.1<br>\
                                    ...<br>\
                                </div>\
                                <p>OR tab delimited text file: </p>\
                                <div class="code">\
                                    CHR\tBP\tP<br>\
                                    1\t10000\t1e-5<br>\
                                    1\t102000\t0.09<br>\
                                    2\t102000\t0.1<br>\
                                    ...<br>\
                                </div>',
                             '<span class="doc-sub-h1">Step 2. Fill the options </span>\
                              <p>Complete the options for PCGA analysis. Move the mouse to the question icon behind the option to see a detailed explanation of the option. \
                              The form can automatically verify the correctness of the input, please follow the prompts to complete the form and submit. </p>\
                              <img src="'+analyze_2+'" width="100%" class="shot_pic"></img><br>\
                              <p>The full explanation of the options is shown in the table below.</p>\
                                <table class="qgg-table"><tbody>'+tips_explanation_table+'</tbody></table>',
                              '<span class="doc-sub-h1">Step 3. Check result page </span>\
                              <p>After submitting the options form, the web page will jump to the submission status page. If the submission is successful, you will see a button to view the results page. Clicking on it will jump to the results page. \
                              <img src="'+analyze_3+'" width="100%" class="shot_pic"></img><br>',
                              '<span class="doc-sub-h1">Step 4. View results </span> \
                              <p>The URL of the result page is unique and fixed, please keep it so you can view it at any time. The result page is kept for one month after completing your job. The results page contains four parts. The first part shows the progress of the job, including GWAS file upload time, job submission time, queuing time, start running and completing time. The second part shows the status of the task running result. If the job runs failed, the reason for the failure will be displayed. The third part shows the basic parameters of the submitted job. If the job is successful, the fourth section will display the results.</p>\
                              <p>The Results section generates a set of results for each reference transcriptome data (including bulk-cell and single-cell RNA-seq). Click the Reference Transcriptome tab to toggle between results. Each set of results contains the corresponding associated tissue/cell type and associated gene. \
                              Statistical P-values are provided to measure the significance of the association. \
                              The dynamic tables are provided here to show the association P-values, meta information of tissues/cell types and genes. Move mouse to the question mark icon at table header to see a detailed explanation of each entry. At the same time, interactive graphics are provided to show the associated P-values ​​of tissues and cells, so that you can insert them in your paper directly. </p>\
                              <img src="'+analyze_4+'" width="100%" class="shot_pic"></img><br>\
                              <span style="font-weight:bold">(1) Associated tissues/cell types results: </span>\
                              <p> Bonferroni correction (family-wise error rate < 0.05) is used to adjust the P-values of associated tissues/cell types.</p> \
                              <img src="'+analyze_4_1+'" width="100%" class="shot_pic"></img><br>\
                              <span style="font-weight:bold">(2) Associated genes results: </span>\
                              <p> Conditionally associated genes\' P-values use the correction method specified by user when submitting the task.</p> \
                              <img src="'+analyze_4_2+'" width="100%" class="shot_pic"></img><br>\
                              <span style="font-weight:bold">(3) Genetically similar phenotypes: </span>\
                              <p>In addition, based on our pre-computed associated gene results of more than a thousand public GWASs, PCGA calculate the genetic similarity between them and the GWAS you uploaded. Genetic similarity is measured by the Jaccard similarity coefficient of significantly associated genes. The genetic similarity will help you recognize the genetic relationship and pathogenic mechanism similarity between your phenotype and other phenotypes.</p> \
                              <img src="'+analyze_4_3+'" width="100%" class="shot_pic"></img><br>',
                            ]
                    },
                ],
                '2-2': [
                    {
                        title: 'Search', paras:
                            ['<span class="doc-sub-h1">Step 1. Search </span>\
                              <p>The website have estimated associated tissues/cell-types and genes of 1,871 public GWASs in 1,588 unique phenotypes, which generated a huge association landscape \
                              among phenome, transcriptome and tissue/cell-type profiles. You can search the association landscape by inputing phenotype, tissue/cell-type or genes.</p>\
                              <img src="'+search_1+'" width="100%"  class="shot_pic"></img><br>',
                             '<span class="doc-sub-h1">Step 2. View association results</span>\
                              <p>The association result page shows the assoication details. If you search for a phenotype, the associated genes and tissue/cell-types of the phenotype will be displayed here.\
                              If you search for a tissue/cell-type, the specifically (or selectively) expressed genes and associated phenotypes will be displayed here. If you search for a gene, \
                              the tissues/cell-types, in which the gene specifically (or selectively) expressed, and associated phenotypes of the gene will be displayed here.\
                              <img src="'+browse_2+'" width="100%" class="shot_pic"></img><br>',
                            ]
                    },
                ], '2-3': [
                    {
                        title: 'Browse', paras:
                            ['<span class="doc-sub-h1">Step 1. Browse </span>\
                              <p>The website allow you to browse the phenotypes and tissues/cell types through a tree structure. The phenotypes were classified by the clinical features. The tissues/cell-types \
                              were classified by the sample source organs of body (e.g., sampling from lung, liver) or cell-type (e.g., B cell, epithelial cell).</p>\
                              <img src="'+browse_1+'" width="100%" class="shot_pic"></img><br>',
                             '<span class="doc-sub-h1">Step 2. View association results </span>\
                            <p>The association result page shows the assoication details. If you browse a phenotype, the associated genes and tissue/cell-types of the phenotype will be displayed here.\
                              If you search for a tissue/cell-type, the specifically (or selectively) expressed genes and associated phenotypes will be displayed here. \
                              <img src="'+browse_2+'" width="100%" class="shot_pic"></img><br>',
                            ]
                    },
                ], '2-4': [
                    {
                        title: 'Explanation', paras:
                            ['',
                            ]
                    },
                ]

            },
            show_con: [],

            form_item: '',
            next_item: '',
            id_label: {},
        }
    },
    created:function(){
        this.getActive_ach_id();
        var il = {};
        this.titles.forEach(ele => {
            ele['children'].forEach(itm => {
                il[itm.ach_id] = itm.label;
            });
        });
        this.id_label = il;
        this.handleChangeID();
    },
    mounted: function () {

    },
    watch: {
        $route:function(){
            this.getActive_ach_id();
            this.handleChangeID();
            backTop();
        },

    },
    methods: {

        getActive_ach_id() {
            if ('id' in this.$route.query) {
                this.active_ach_id = this.$route.query.id;
            }
        },
        goTo: function (navi_iterm) {
            this.$router.push({ path: '/' + navi_iterm });
        },
        setManu() {
            if (this.isCollapse) {
                this.manu_width = '240px';
                this.isCollapse = false;
                this.fold_icon='el-icon-s-fold'
                document.querySelector('.main_con_div').style.padding='0px 25px 20px 25px';
            } else {
                this.manu_width = '0px';
                this.isCollapse = true;
                this.fold_icon='el-icon-s-unfold'
                document.querySelector('.main_con_div').style.padding='20px 25px 20px 50px ';
            }
        },
        handleSelect(key) {
            // this.active_ach_id=key;
            this.$router.push({ path: '/document?id=' + key });
            // this.$route.query.id=key;
            // this.show_con = this.con_text[key];
        },
        formerPart() {
            var idx = this.all_titles.indexOf(this.active_ach_id) - 1;
            this.active_ach_id = this.all_titles[idx];
            this.$router.push({ path: '/document?id=' + this.active_ach_id });
        },
        nextPart() {
            var idx = this.all_titles.indexOf(this.active_ach_id) + 1;
            this.active_ach_id = this.all_titles[idx];
            this.$router.push({ path: '/document?id=' + this.active_ach_id });
        },
        handleChangeID() {
            var idx = this.all_titles.indexOf(this.active_ach_id);
            this.form_item = this.id_label[this.all_titles[idx - 1]];
            this.next_item = this.id_label[this.all_titles[idx + 1]];
            this.show_con = this.con_text[this.active_ach_id];
        }
    }
}
</script>

<style>
.qgg-table{
    border-collapse: collapse;
    width:100%;
    border:1px solid #c6c6c6 !important;
    margin-bottom:20px;
}
.qgg-table th{
    border-collapse: collapse;
    border-right:1px solid #c6c6c6 !important;
    border-bottom:1px solid #c6c6c6 !important;
    background-color:#A0CFFF !important; 

    padding:5px 9px;
    /* font-size:14px; */
    font-weight:normal;
    text-align:center;
    font-weight: bold;
}
.qgg-table td{
    border-collapse: collapse;
    border-right:1px solid #c6c6c6 !important;
    border-bottom:1px solid #c6c6c6 !important; 
    padding:5px 9px;
    font-size:14px;
    font-weight:normal;
    text-align:left;
    word-break: break-all;
}
.qgg-table tr:nth-child(odd){
    background-color:#fff !important; 
}
.qgg-table tr:nth-child(even){
    background-color: #f8f8f8 !important;
}
.code{
    padding:10px 15px;
    background-color: #FDF6E3;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: 13px;
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    line-height: 18px;
}
.doc-sub-h1{
    font-weight:bold;
    font-size:18px
}
.shot_pic{
    margin-top: 15px;
}
</style>

<style scoped>
.el-h1-title {
    font-size: 14px;
    font-weight: bold;
}
.el-h2-title {
    font-size: 14px;
}
.manu,
.mamu_div {
    background-color: #f7f7f7;
}

.main_con {
    padding: 0px;
}

.main_con_div {
    padding: 0px 25px 20px 25px;
    z-index: -1;
}

.footer-nav {
    margin-top: 30px;
}


</style>


// WEBPACK FOOTER //
// src/views/document.vue